export default "__VITE_ASSET__h7NS59Wt__"